var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _setup.showStaticAlert
      ? _c("div", { class: ["static-alert-container", _setup.getAlertType] }, [
          _c("span", { class: [_setup.getAlertIcon, "alert-icon"] }),
          _c("div", { staticClass: "alert-info-container" }, [
            _vm.alert.title
              ? _c("div", { staticClass: "alert-title" }, [
                  _vm._v(_vm._s(_vm.alert.title)),
                ])
              : _vm._e(),
            _c("div", { domProps: { innerHTML: _vm._s(_vm.alert.message) } }),
            _vm.alert.acceptLink || _vm.alert.cancelLink
              ? _c("div", { staticClass: "alert-links" }, [
                  _vm.alert.acceptLink
                    ? _c(
                        "div",
                        {
                          staticClass: "link",
                          on: { click: _vm.alert.acceptLink.callback },
                        },
                        [_vm._v(" " + _vm._s(_vm.alert.acceptLink.text) + " ")]
                      )
                    : _vm._e(),
                  _vm.alert.cancelLink
                    ? _c(
                        "div",
                        {
                          staticClass: "link",
                          on: { click: _vm.alert.cancelLink.callback },
                        },
                        [_vm._v(" " + _vm._s(_vm.alert.cancelLink.text) + " ")]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm.alert.cancelButton
            ? _c("div", {
                staticClass: "lf-icon-close close-icon",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.closeStaticAlert.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }